export function get_array_item(key, value, arr) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i][key] == value) {
			return arr[i];
		}
	}
	return null;
}

export function sanitize_title(text) {
	return text.toLowerCase().replaceAll(' ', '-');
}

export function get_animation_duration(el) {
	return get_time_value(window.getComputedStyle(el).animationDuration);
}

export function get_time_value(value) {
	let temp = value.toString();
	if (temp.indexOf('ms') !== -1) {
		return parseFloat(value);
	} else if (temp.indexOf('s') !== -1) {
		return parseFloat(value) * 1000;
	}
	return null;
}

export function format_date(date, format = 'm/d/y') {
	let y = date.getFullYear();

	let m = date.getMonth() + 1;
	if (m < 10) {
		m = '0' + m;
	}

	let d = date.getDate();
	if (d < 10) {
		d = '0' + d;
	}

	let date_format = {
		m,
		d,
		y,
	};

	let date_format_output = format;
	for (let key in date_format) {
		date_format_output = date_format_output.replace(key, date_format[key]);
	}

	return date_format_output;
}

export function apply_template(template, item) {
	for (let key in item) {
		template = template.replaceAll('{{item.' + key + '}}', item[key]);
	}
	return template;
}

export function assign_element(selector, multiple = false) {
	if (typeof selector === 'string') {
		if (multiple) {
			return document.querySelectorAll(selector);
		} else {
			return document.querySelector(selector);
		}
	} else if (typeof selector === 'object') {
		return selector;
	}
	return null;
}

export function add_classes(item, add_classes) {
	add_classes.split(' ').forEach((add_class) => {
		item.classList.add(add_class);
	});
}

export function create_element({
	id = '',
	class_name = '',
	append_to = '',
	prepend_to = '',
	tag = 'div',
	text = '',
    html = '',
	anonymous = false,
}) {
	if (!class_name) class_name = id;

	let element = document.createElement(tag);

	if (!anonymous && id) {
		id = element;
	}

	if (class_name) {
		add_classes(element, class_name);
	}

	if (text) {
		element.textContent = text;
	}

    if (html) {
		element.innerHTML = html;
	}

	if (append_to) {
		append_to.append(element);
	}

	if (prepend_to) {
		prepend_to.prepend(element);
	}

	return element;
}

export function create_dom(html) {
	let temp_element = document.createElement('div');
	temp_element.innerHTML = html;
	return temp_element.children[0];
}

export function wrap_element(el, class_names = '') {
	let wrapper = document.createElement('div');
	class_names.split(' ').forEach((class_name) => {
		wrapper.classList.add(class_name);
	});
	el.after(wrapper);
	wrapper.append(el);
	return wrapper;
}

export function lerp(a, b, t) {
	return a * (1 - t) + b * t;
}

export function onscreen(el, options = {}) {
	if (typeof el === 'string') {
		el = document.querySelector(el);
	}

	let once = options.once ?? false;
	let observer_options = options.observer_options ?? {};
	let observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				if (typeof options.on === 'function') {
					options.on(entry, observer);
					if (once) {
						observer.unobserve(entry.target);
					}
				}
			} else {
				if (typeof options.off === 'function') {
					options.off(entry, observer);
				}
			}
		});
	}, observer_options);

	observer.observe(el);
}

export function items_animation_delay(
	el,
	items_selector = false,
	interval = 150
) {
	if (typeof el === 'string') el = document.querySelector(el);
	if (!el) return;
	let children = items_selector
		? el.querySelectorAll(items_selector)
		: el.childNodes;
	let time = 0;
	children.forEach((item) => {
		item.style.animationDelay = time + 'ms';
		time += interval;
	});
}

export function scroll_to(items, options = {}) {
	if (typeof items === 'string') {
		items = document.querySelectorAll(items);
	}
	let default_offset = options.default_offset ?? 0;
	items.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			let target = document.querySelector(item.attributes.href.value);
			if (!target) return;
			let offset = item.dataset.offset ?? default_offset;
			let top = target.offsetTop - parseInt(offset);
			window.scrollTo({
				top,
				behavior: 'smooth',
			});
		});
	});
}

export function hover_intent(el, duration = 200, hover_class = 'hover') {
	if (typeof el === 'string') {
		el = document.querySelector(el);
	}

	if (!el || typeof el.hover_intent !== 'undefined') return;

	el.hover_intent = null;

	el.addEventListener('pointerenter', () => {
		clearTimeout(el.hover_intent);
		el.classList.add(hover_class);
	});

	el.addEventListener('pointerleave', () => {
		clearTimeout(el.hover_intent);
		el.hover_intent = setTimeout(() => {
			el.classList.remove(hover_class);
		}, duration);
	});
}

export function display_message(options) {
	const html = document.createElement('div');
	html.textContent = options.text;

	html.classList.add('msg');

	if (typeof options.class !== 'undefined') {
		html.classList.add(options.class);
	}

	// placement
	if (typeof options.after !== 'undefined') {
		options.after.after(html);
	} else if (typeof options.before !== 'undefined') {
		options.before.before(html);
	}

	if (typeof options.remove !== 'undefined') {
		setTimeout(() => {
			html.remove();
		}, options.remove);
	}
}

export function animate_items(items, options = {}) {
	if (typeof items === 'string') {
		items = document.querySelectorAll(items);
	}

	let stagger = options.stagger ?? 50;
	let limit = options.limit ?? 30;
	let animation =
		options.animation ??
		'fade-in-bottom-short 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both';

	let stagger_increment = 0;
	let item_count = 0;
	items.forEach((item) => {
		if (item_count < limit) {
			item.style.animation = animation;
			item.style.animationDelay = stagger_increment + 'ms';
		}

		item.style.display = '';

		stagger_increment += stagger;
		item_count++;
	});
}

export function is_elementor_edit() {
	// console.log('is_elementor_edit', window.location.search.indexOf('elementor-preview=') !== -1)
	return window.location.search.indexOf('elementor-preview=') !== -1;
}

export function on_ready(fn) {
	if (document.readyState === 'loading') {
		// Loading hasn't finished yet
		document.addEventListener('DOMContentLoaded', () => fn());
	} else {
		// `DOMContentLoaded` has already fired
		fn();
	}
}

export function on_resize(cb, throttle_time = 500) {
    let throttling = false;
    let queue_cb = null;
    let queue_waiting = false;
	window.addEventListener('resize', () => {
        if( throttling ) {
            queue_cb = cb;
            if( !queue_waiting ) {
                setTimeout(() => {
                    queue_cb();
                    queue_waiting = false;
                }, throttle_time);
            }
            queue_waiting = true;
            return;
        }
        throttling = true;
        cb();
        setTimeout(() => {
            throttling = false;
		}, throttle_time);
	});
}

export function debounce(callback, wait = 100){
    let timeout_id = null;
    return (...args)=>{
        clearTimeout(timeout_id);
        timeout_id = setTimeout(()=>{
            callback.apply(null, args);
        }, wait);
    };
}

export function create_div(class_name, append_to = null, text = null){

    const div = document.createElement('div');
    div.className = class_name;

    if( append_to ) {
        if( typeof append_to === 'string' ) {
            append_to = document.querySelector(append_to);
        }
        append_to.append(div);
    }

    if( text ) div.textContent = text;

    return div;
}

export function set_cookie(cookie_name, cookie_value, expiration_hours = 3, path = '/') {
	const d = new Date();
	d.setTime(d.getTime() + expiration_hours * 60 * 60 * 1000);
	let expires = 'expires=' + d.toUTCString();
	document.cookie = cookie_name + '=' + cookie_value + ';' + expires + ';path='+ path;
}

export function get_cookie(cookie_name) {
	let name = cookie_name + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

export function remove_cookie(cookie_name, path = '/') {
    document.cookie = cookie_name +"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path="+path+";";
}

export function copy_to_clipboard(text){
    try {
        navigator.clipboard.writeText(text);
    } catch(e) {
        copy_to_clipboard_legacy_support(text);
    }
}

function copy_to_clipboard_legacy_support(text){
    var el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style = {position: 'absolute', left: '-9999px'};
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}
